var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "input-item" },
      [
        _c("label", { staticClass: "contactum-label" }, [
          _vm._v(_vm._s("Scale From"))
        ]),
        _vm._v(" "),
        _c("el-input-number", {
          staticClass: "full-width",
          attrs: { "controls-position": "right", min: "1" },
          model: {
            value: _vm.editfield.scale_range.from,
            callback: function($$v) {
              _vm.$set(_vm.editfield.scale_range, "from", $$v)
            },
            expression: "editfield.scale_range.from"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "input-item" },
      [
        _c("label", { staticClass: "contactum-label" }, [
          _vm._v(_vm._s("Scale To"))
        ]),
        _vm._v(" "),
        _c("el-input-number", {
          staticClass: "full-width",
          attrs: {
            "controls-position": "right",
            min: "editfield.scale_range.from"
          },
          model: {
            value: _vm.editfield.scale_range.to,
            callback: function($$v) {
              _vm.$set(_vm.editfield.scale_range, "to", $$v)
            },
            expression: "editfield.scale_range.to"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "input-item" },
      [
        _c("label", { staticClass: "contactum-label" }, [
          _vm._v(_vm._s("Scale First Text"))
        ]),
        _vm._v(" "),
        _c("el-input", {
          model: {
            value: _vm.editfield.scale_text.first,
            callback: function($$v) {
              _vm.$set(_vm.editfield.scale_text, "first", $$v)
            },
            expression: "editfield.scale_text.first"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "input-item" },
      [
        _c("label", { staticClass: "contactum-label" }, [
          _vm._v(_vm._s("Scale Last Text"))
        ]),
        _vm._v(" "),
        _c("el-input", {
          model: {
            value: _vm.editfield.scale_text.last,
            callback: function($$v) {
              _vm.$set(_vm.editfield.scale_text, "last", $$v)
            },
            expression: "editfield.scale_text.last"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }